import React, { useCallback, useRef, useState } from 'react';

import { QuickFindSkeleton as QuickFindSkeletonInternal } from '@atlassian/search-page/quick-find-skeleton';

import { LoadableAfterPaint } from '@confluence/loadable';
import { useRouteActions } from '@confluence/route-manager/entry-points/RouteState.ts';
import { CONTEXT_PATH } from '@confluence/named-routes/entry-points/context.ts';
import { useIsNav4Enabled } from '@confluence/nav4-enabled/entry-points/useIsNav4Enabled.ts';

import { getPersistedGhostText } from './utils/getPersistedGhostText.ts';

export const QuickFindSkeleton = () => {
	const { push } = useRouteActions();
	const isNav4Enabled = useIsNav4Enabled();
	const inputRef = useRef<HTMLInputElement>(null);
	const [customPlaceholder] = useState(() => getPersistedGhostText(inputRef));

	const onEnter = useCallback(
		(e: React.KeyboardEvent) => {
			const input = e.target as HTMLInputElement;
			input.blur();
			push(`${CONTEXT_PATH}/search/?text=${input.value}`);
		},
		[push],
	);
	return (
		<QuickFindSkeletonInternal
			onEnter={onEnter}
			isNav4Enabled={isNav4Enabled}
			customPlaceholder={customPlaceholder}
			inputRef={inputRef}
		/>
	);
};

export const QuickFindAsync = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-QuickFind" */ './QuickFind.tsx')).QuickFind,
	loading: () => <QuickFindSkeleton />,
});
